const {
  evaluateSource
} = require('../../lib/evaluateSource');

/**
  * @function evalute - evaluate pyroStandardRecallDateBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const dateString = await evaluateSource(source.date, content, parentContentPath, transientContext, nativeFunctions);
  if (dateString === undefined) {
    return undefined;
  }
  const date = new Date(dateString);
  if (Number.isNaN(date)) {
    return undefined;
  }
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();

  // standard recall date is 20xx-03-01, 20xx-06-01, 20xx-09-01, or 20xx-12-01
  // whichever is next!

  const nextQuarter = Math.floor((month + 1) / 3);
  const nextMonth = nextQuarter < 4 ? 3 * nextQuarter + 2 : 2;
  const nextYear = nextQuarter < 4 ? year : year + 1;
  const nextDate = new Date(Date.UTC(nextYear, nextMonth, 1, date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
  return nextDate.toISOString();
};
module.exports = {
  evaluate
};